/**
 * @author HungNS
 */
import * as TYPE from "./type";
import IConstants from "@/common/constants/IConstants.js";
import FactoryService from "@/services/FactoryService.js";
const dashboardService = FactoryService.getService('dashboard');

const moduleDashboard = {
  namespaced: true,
  state: () => ({
    balanceInfoView: null,
    serverTime: null,
    totalEquity: 0,
    listAmsCustomerNewsView: [],
    ntdFxMaintenance: false,
    scMaintenance: false,
    cryptMaintenance: false
  }),
  mutations: {
    [TYPE.SET_BALANCE_INFO](state, payload) {
      state.balanceInfoView = payload.amsBalanceInfoViews;
    },
    [TYPE.SET_TOTAL_EQUITY](state, payload) {
      state.totalEquity = payload.totalEquity;
    },
    [TYPE.SET_CUSTOMER_NEWS](state, payload) {
      state.listAmsCustomerNewsView = payload.listAmsCustomerNewsView;
    },
    [TYPE.SET_SERVER_TIME](state, payload) {
      state.serverTime = payload.serverTime;
    },
    [TYPE.SET_NTD_FX_MAINTENANCE](state, payload) {
      state.ntdFxMaintenance = payload
    },
    [TYPE.SET_SC_MAINTENANCE](state, payload) {
      state.scMaintenance = payload
    },
    [TYPE.SET_CRYPTO_MAINTENANCE](state, payload) {
      state.cryptMaintenance = payload
    }
  },
  actions: {
    async [TYPE.GET_BALANCE_INFO]({ commit }) {
      const data = await dashboardService.getBanlanceInfo();
      commit(TYPE.SET_BALANCE_INFO, data);
      commit(TYPE.SET_TOTAL_EQUITY, data);
      commit(TYPE.SET_NTD_FX_MAINTENANCE, data.ntdFxMaintenance);
      commit(TYPE.SET_SC_MAINTENANCE, data.scMaintenance);
      commit(TYPE.SET_CRYPTO_MAINTENANCE, data.cryptoMaintenance);
    },
    async [TYPE.GET_CUSTOMER_NEWS]({ commit }) {
      const data = await dashboardService.getCustomerNews();
      commit(TYPE.SET_CUSTOMER_NEWS, data)
    },
    async [TYPE.GET_SERVER_TIME]({ commit }) {
      const data = await dashboardService.getServerTime();
      commit(TYPE.SET_SERVER_TIME, data);
    },
  },
  getters: {
    serviceBalanceBlocks: (state, getters, rootState) => {
      let serviceBalanceBlocks = [];
      let { headerInfo } = rootState["header"];
      const { balanceInfoView , ntdFxMaintenance, scMaintenance, cryptMaintenance} = state;
      if (headerInfo) {
        const { hasSocialAccount, hasBoAccount, hasNtdAccount, hasCryptAccount } = headerInfo;
        let amsBalance, boBalance, socialBalance, ntdBalance, cryptBalance;
        if (balanceInfoView) {
          if (balanceInfoView[IConstants.SERVICE_TYPE.AMS]) {
            amsBalance = balanceInfoView[IConstants.SERVICE_TYPE.AMS];
          }

          if (balanceInfoView[IConstants.SERVICE_TYPE.BO]) {
            boBalance = balanceInfoView[IConstants.SERVICE_TYPE.BO];
          }

          if (balanceInfoView[IConstants.SERVICE_TYPE.SOCIAL]) {
            socialBalance = balanceInfoView[IConstants.SERVICE_TYPE.SOCIAL];
          }

          if (balanceInfoView[IConstants.SERVICE_TYPE.NTD_FX]) {
            ntdBalance = balanceInfoView[IConstants.SERVICE_TYPE.NTD_FX];
          }

          if (balanceInfoView[IConstants.SERVICE_TYPE.CRYPTO_FX]) {
            cryptBalance = balanceInfoView[IConstants.SERVICE_TYPE.CRYPTO_FX];
          }

          const ntdFxBlock = {
            id: "ntdfx",
            hasServiceBalance: hasNtdAccount,
            hasMultiBlock: false,
            isMaintenance: ntdFxMaintenance,
            balanceBlock: [
              {
                title: "account.ntdfx",
                frontHeaderTitle: "trs.front.header.label.fx",
                fields: {
                  "dashboard.label.equity_ntd": ntdBalance?.equityView ?? 0,
                  "dashboard.label.balance": ntdBalance?.cashBalanceView ?? 0,
                  "dashboard.label.unrealize_pl":
                    ntdBalance?.unrealizedPLView ?? 0,
                },
              },
            ],
          };

          const copytradeBlock = {
            id: "copytrade",
            hasServiceBalance: hasSocialAccount,
            hasMultiBlock: false,
            isMaintenance: scMaintenance,
            balanceBlock: [
              {
                title: "account.copytrade",
                frontHeaderTitle: "trs.front.header.label.social",
                fields: {
                  "dashboard.label.equity.sc.public":
                    socialBalance?.equityView ?? 0,
                  "dashboard.label.balance":
                    socialBalance?.cashBalanceView ?? 0,
                  "dashboard.label.unrealize_pl":
                    socialBalance?.unrealizedPLView ?? 0,
                },
              },
            ],
          };

          const cryptoFxBlock = {
            id: "cryptofx",
            hasServiceBalance: hasCryptAccount,
            hasMultiBlock: false,
            isMaintenance: cryptMaintenance,
            balanceBlock: [
              {
                title: "account.cryptofx",
                frontHeaderTitle: "trs.front.header.label.crypt",
                fields: {
                  "dashboard.label.equity_crypt": cryptBalance?.equityView ?? 0,
                  "dashboard.label.balance": cryptBalance?.cashBalanceView ?? 0,
                  "dashboard.label.unrealize_pl":
                    cryptBalance?.unrealizedPLView ?? 0,
                },
              },
            ],
          };

          const amsBlock = {
            id: "ams",
            hasServiceBalance: true,
            hasMultiBlock: true,
            isMaintenance: false,
            balanceBlock: [
              {
                hasServiceBalance: hasBoAccount,
                title: "account.bo",
                fields: {
                  "dashboard.label.balance": boBalance?.cashBalanceView ?? 0,
                },
              },
              {
                hasServiceBalance: true,
                title: "account.ams",
                fields: {
                  "dashboard.label.balance": amsBalance?.cashBalanceView ?? 0,
                  "dashboard.label.reserved_amount":
                    amsBalance?.reservedAmountView ?? 0,
                },
              },
            ],
          };

          serviceBalanceBlocks = [
            ntdFxBlock,
            copytradeBlock,
            cryptoFxBlock,
            amsBlock,
          ];
        }
      }
      return serviceBalanceBlocks;
    },
    activeServicesHasSigleBlock: (state, getters) => {
      const { serviceBalanceBlocks } = getters;
      if (serviceBalanceBlocks.length > 0) {
        return serviceBalanceBlocks.filter((item) => {
          return item.hasServiceBalance && !item.hasMultiBlock;
        });
      } else {
        return [];
      }
    },
    activeServicesHasMultiBlock: (state, getters) => {
      const { serviceBalanceBlocks } = getters;
      if (serviceBalanceBlocks.length > 0) {
        return serviceBalanceBlocks.filter((item) => {
          return item.hasServiceBalance && item.hasMultiBlock;
        });
      } else {
        return [];
      }
    },
  },
};
export default moduleDashboard;
